module.exports = __webpack_public_path__ + "img/tdscj.ef1e8aa9.svg";